import { gql } from '@apollo/client';

export const CREATE_FAVORITE_BUILDING = gql`
  mutation ($data: FavoriteBuildingInput!) {
    createFavoriteBuilding(data: $data) {
      data {
        id
      }
    }
  }
`;

export const DELETE_FAVORITE_BUILDING = gql`
  mutation ($id: ID!) {
    deleteFavoriteBuilding(id: $id) {
      data {
        id
      }
    }
  }
`;
